const LEGAL = [
  ["Terms", "https://anomalos.com/legal/terms"],
  ["Privacy Policy", "https://anomalos.com/legal/privacy"],
  ["Cookie Policy", "https://anomalos.com/legal/cookies"],
] as const;

export const LegalConsent = () => (
  <p className="m-0 text-[13px] text-n-600 leading-[1.5]">
    By continuing, you agree to Anomalos, Inc’s{" "}
    <a
      className="auth-underline text-coral-700"
      href={LEGAL[0][1]}
      rel="noopener noreferrer"
      target="_blank"
    >
      {LEGAL[0][0]}
    </a>
    ,{" "}
    <a
      className="auth-underline text-coral-700"
      href={LEGAL[1][1]}
      rel="noopener noreferrer"
      target="_blank"
    >
      {LEGAL[1][0]}
    </a>{" "}
    and{" "}
    <a
      className="auth-underline text-coral-700"
      href={LEGAL[2][1]}
      rel="noopener noreferrer"
      target="_blank"
    >
      {LEGAL[2][0]}
    </a>
    .
  </p>
);
